import type { Locale } from '@/lib/i18n';

export function parseDropLogDate(dropDate: string): Date {
  if (!dropDate) return new Date(NaN);

  const direct = new Date(dropDate);
  if (!Number.isNaN(direct.getTime())) return direct;

  const normalized = String(dropDate).trim().replace(' ', 'T');
  const withT = new Date(normalized);
  if (!Number.isNaN(withT.getTime())) return withT;

  return new Date(NaN);
}

export function formatDropLogDate(dropDate: string, _locale: Locale): string {
  const parsed = parseDropLogDate(dropDate);
  if (Number.isNaN(parsed.getTime())) return '—';

  const pad = (n: number) => String(n).padStart(2, '0');
  const day = pad(parsed.getDate());
  const month = pad(parsed.getMonth() + 1);
  const year = String(parsed.getFullYear()).slice(-2);
  const hours = pad(parsed.getHours());
  const minutes = pad(parsed.getMinutes());

  return `${day}/${month}/${year} ${hours}:${minutes}`;
}

export function formatDropLogTimeAgo(
  dropDate: string,
  t: (key: string, params?: Record<string, string | number>) => string,
): string {
  const parsed = parseDropLogDate(dropDate);
  const dropMs = parsed.getTime();
  if (Number.isNaN(dropMs)) return '';

  const diffSec = Math.floor((Date.now() - dropMs) / 1000);
  if (diffSec < 60) {
    return `${diffSec} ${t('log_time_seconds')}`;
  }
  if (diffSec < 3600) {
    return `${Math.floor(diffSec / 60)} ${t('log_time_minutes')}`;
  }
  if (diffSec < 86400) {
    return `${Math.floor(diffSec / 3600)} ${t('log_time_hours')}`;
  }
  return `${Math.floor(diffSec / 86400)} ${t('log_time_days')}`;
}
